import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { DASHBOARD_LOAN_DETAILS } from "routes";

export const COLUMNS = [
  {
    Header: "Applicant",
    accessor: row => `${row.surname} ${row.first_name}`,
  },
  {
	Header: "BVN",
	accessor: "bvn",
  },
  {
	Header: "Date of Birth",
	accessor: "dob",
	Cell: ({ value }) => {
		return dayjs(value).format('DD/MM/YYYY');
	  },
  },
  {
    Header: "Phone No",
    accessor: "phone",
  },
  {
    Header: "Email",
    accessor: "email",
  }
];


export const REAPPLICANT_COLUMN = [
  {
    title: "S/N",
    key:"s/n",
    fixed:"left",
    render: (_,originalRow,index) => <p>{index + 1}</p>
  },
  {
    title: "Applicant",
    key:"applicant",
    width:250,
    render: (_,originalRow,) => {
      const applicant = originalRow.applicant || originalRow.reapplicant
      return (
        <div style={{ maxWidth: "250px" }}>{applicant?.first_name} {applicant?.surname}</div>
      )
    }
  },
  {
    title: "Loan Amount",
    key:"loan_amount",
    width:250,
    render: (_,originalRow,) => {
      return (
        <div style={{ maxWidth: "250px" }}>₦{originalRow?.amount?.toLocaleString()}</div>
      )
    }
  },
  {
    title: "Disburse Date",
    key:"loan_amount",
    width:250,
    render: (_,originalRow,) => {
      return (
        <div style={{ maxWidth: "250px" }}>{dayjs(originalRow.disburse_date).format('DD/MM/YYYY')}</div>
      )
    }
  },
  {
    title: "BVN",
    key:"bvn",
    width:250,
    render: (_,originalRow,) => {
      const applicant = originalRow.applicant || originalRow.reapplicant
      return (
        <div style={{ maxWidth: "250px" }}>{applicant?.bvn}</div>
      )
    }
  },
  {
    title: "Date of Birth",
    key:"dob",
    width:250,
    render: (_,originalRow,) => {
      const applicant = originalRow.applicant || originalRow.reapplicant
      return (
        <div style={{ maxWidth: "250px" }}>{dayjs(applicant.dob).format('DD/MM/YYYY')}</div>
      )
    }
  },
  {
    title: "Phone Number",
    key:"Phone number",
    width:200,
    render: (_,originalRow,) => {
      const applicant = originalRow.applicant || originalRow.reapplicant
      return (
        <div style={{ maxWidth: "250px" }}>{applicant.phone}</div>
      )
    }

  },
  {
    title: "Email",
    key:"email",
    width:250,
    render: (_,originalRow,) => {
      const applicant = originalRow.applicant || originalRow.reapplicant
      return (
        <div style={{ maxWidth: "250px" }}>{applicant?.email}</div>
      )
    }
  },
  {
    title: "More",
    key:"more",
    fixed:"right",
    width:150,
    render: (_,originalRow,) => <Link to={`${DASHBOARD_LOAN_DETAILS}/${originalRow.id}`}><button className="px-6 py-1 justify-center font-semibold rounded-full border border-primary-300 bg-secondary-50 text-primary-700">View</button></Link>
  },
]
